var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-width fill-height"},[_c('iframe',_vm._b({attrs:{"frameborder":"0"}},'iframe',_vm.props,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }